module.exports = __webpack_public_path__ + "img/088-uruguay.06c0b922.svg";